import { Subject } from 'rxjs';
import { IRouteOptions } from '../interfaces/route-options.interface';

export const routeListener = new Subject<IRouteOptions>();
